import {Api} from '@/App';

export function reqCertificate(courseId: string) {
  return Api.get(`/courses/${courseId}/certificate`);
}
